module.exports = __webpack_public_path__ + "static/media/hangouts.adca7221.png";